import React from 'react';

const RadioButton = ({ options, selectedValue, handleGstRadioBtn, disabled }) => {
    return (
        <>
            <div className="d-flex align-items-center">
                {options.map((option) => (
                    <div className="check-form" key={option.value}>
                        <label htmlFor={option.value}>
                            <input
                                type="radio"
                                name="flexRadioDefault"
                                id={option.value}
                                disabled={disabled}
                                checked={selectedValue === option.value}
                                onChange={handleGstRadioBtn}
                            />
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
        </>
    );
};

export default RadioButton;